import { ReactNode, useEffect } from 'react';

import { CURRENT_ENTITY_ID } from 'hooks/keys';
import useGetCurrentEntityId, { notifyCurrentEntityIdChanged } from 'hooks/useGetCurrentEntityId';
import { useStorage } from 'hooks/useStorage';
import useGetUser from 'hooks/useGetUser';

const InitialHandler = ({
    children,
}: {
    children: ReactNode;
}) => {
    const user = useGetUser();
    const currentEntityId = useGetCurrentEntityId();
    const { specifiedSetItem } = useStorage('local', user?.id ?? '');

    useEffect(() => {
        if (!user || !user.entities.length || currentEntityId) {
            return;
        }

        const defaultEntityId = user.entities.find((entity) => entity.isParish)?.id ?? user.entities[0].id;
        specifiedSetItem(CURRENT_ENTITY_ID, defaultEntityId);
        notifyCurrentEntityIdChanged(user.id, defaultEntityId);
    }, [currentEntityId, specifiedSetItem, user]);

    return (
        <div>
            {children}
        </div>
    );
};

export default InitialHandler;
